"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BURN_REDEEM_1155_V1_ABI_json_1 = tslib_1.__importDefault(require("../abis/burnredeem/BURN_REDEEM_1155_V1_ABI.json"));
const BURN_REDEEM_1155_V2_ABI_json_1 = tslib_1.__importDefault(require("../abis/burnredeem/BURN_REDEEM_1155_V2_ABI.json"));
const BURN_REDEEM_1155_V3_ABI_json_1 = tslib_1.__importDefault(require("../abis/burnredeem/BURN_REDEEM_1155_V3_ABI.json"));
const ContractVersion_1 = require("./ContractVersion");
class BurnRedeem1155Version extends ContractVersion_1.ContractVersion {
    constructor() {
        super(...arguments);
        // @dev: the latest current version
        this.version = "v3.1";
        this.deployedContractsByVersion = {
            "v1.0": {
                goerliAddress: "0xB52Dd65595bdB875B88e25F8cC63229E78205C2e",
                mainnetAddress: "0xa4fb4bfbd70Ae8C81eCe9E0FCCefFa9953e120cB",
                abi: BURN_REDEEM_1155_V1_ABI_json_1.default,
            },
            "v2.0": {
                goerliAddress: "0x22822100c2cA8DB1E35dd090E1226f2b8a8e736E",
                mainnetAddress: "0xfa1B15dF09c2944a91A2F9F10A6133090d4119BD",
                abi: BURN_REDEEM_1155_V2_ABI_json_1.default,
            },
            "v3.0": {
                goerliAddress: "0x193bFD86F329508351ae899A92a963d5bfC77190",
                mainnetAddress: "0xde659726CfD166aCa4867994d396EFeF386EAD68",
                abi: BURN_REDEEM_1155_V3_ABI_json_1.default,
            },
            "v3.1": {
                goerliAddress: "0x193bFD86F329508351ae899A92a963d5bfC77190",
                mainnetAddress: "0xde659726CfD166aCa4867994d396EFeF386EAD68",
                abi: BURN_REDEEM_1155_V3_ABI_json_1.default,
            },
        };
    }
}
exports.default = new BurnRedeem1155Version();
//# sourceMappingURL=BurnRedeem1155Version.js.map